import { type FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AuthApiError, getAuthClient } from '@/api/client';
import { errorMessage } from '@/lib/errorMap';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await getAuthClient().forgotPassword(email);
      // local 모드는 응답 message 에 reset_token 노출 — 그대로 표시
      setSent(res.message ?? '입력된 이메일로 재설정 안내를 발송했습니다');
    } catch (e) {
      if (e instanceof AuthApiError) toast.error(errorMessage(e.code));
      else toast.error('네트워크 오류');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>비밀번호 찾기</CardTitle>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="flex flex-col gap-3">
              <p className="text-sm text-muted-foreground">{sent}</p>
              <Button asChild>
                <Link to="/login">로그인 화면으로</Link>
              </Button>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <Label htmlFor="email">가입한 이메일</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  required
                />
              </div>
              <Button type="submit" disabled={submitting}>
                {submitting ? '전송 중...' : '재설정 링크 받기'}
              </Button>
              <Link
                to="/login"
                className="text-center text-sm text-muted-foreground hover:underline"
              >
                로그인으로 돌아가기
              </Link>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
